import { render, staticRenderFns } from "./checkout_by_phone.vue?vue&type=template&id=3b546706&scoped=true"
import script from "./checkout_by_phone.vue?vue&type=script&lang=js"
export * from "./checkout_by_phone.vue?vue&type=script&lang=js"
import style0 from "./checkout_by_phone.vue?vue&type=style&index=0&id=3b546706&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b546706",
  null
  
)

export default component.exports